
export default {
    name: 'PromptDialog',
    components: {
        Dialog: () => import(/* webpackChunkName: "Dialog" */ '~/components/ui/Dialog')
    },
    props: {
        show: { default: false },
        slotted: { default: false },
        title: { default: '' },
        text: { default: '' },
        type: { default: 'primary' },
        primaryAction: { default: () => ({ text: 'Yes'})},
        secondaryAction: { default: () => ({ text: 'Cancel' }) },
        actionAlign: { type: String, default: 'center' }
    },
    data: () => ({
        data: null
    }),
    watch: {
        show(val) {
            if (val) { this.open() } else { this.close() }
        }
    },
    methods: {
        open(data) {
            this.data = data
            this.$refs.Dialog.open()
        },
        close() {
            this.data = null
            this.$refs.Dialog.cancel()
        },
        accept() {
            this.$emit('accept', this.data)
            this.$refs.Dialog.close()
        }
    }
}
